/**
 * Kit de soporte v1 — borrador y límites del formulario "Reportar un problema"
 * (ADR-0025): "¿Qué pasó?" más una captura opcional, y la entidad de la
 * pantalla, llenada desde la ruta y editable.
 */

export const DESC_MIN = 10;
export const DESC_MAX = 2000;
export const MAX_CAPTURA_MB = 5;
export const IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp"];

export interface ReportDraft {
  entidadId: string;
  descripcion: string;
  captura: File | null;
}

export function emptyDraft(entidadId: string | null = null): ReportDraft {
  return { entidadId: entidadId ?? "", descripcion: "", captura: null };
}
